import React from "react";
import "./Progressive.css";
import "./Progressivecommon.css";
import ProgressiveHero from "./progressivehero/ProgressiveHero";
import Range from "./range/Range";
import Future from "./future/Future";
import Agile from "./agile/Agile";
import Testimonial from "./testimonialprogressive/Testimonial";
import Services from "./serviceprogressive/Services";

const Progressive = () => {
  return (
    <div id="progressive">
      <ProgressiveHero />
      <Range/>
      <Future />
      <Agile />                            
      <Testimonial />
      <Services />
    </div>
  );
};

export default Progressive;
